import cn from './styles.module.css';

const AgreementsHeader = () => (
  <div className={cn.agremeentsContentHeader}>
    <div className={cn.agreementsContentHeaderValue}>Type</div>
    <div className={cn.agreementsContentHeaderValue}>Version</div>
    <div className={cn.agreementsContentHeaderValue}>Date of signing</div>
  </div>
);

export default AgreementsHeader;
